import { render, staticRenderFns } from "./CompetitionAdding.vue?vue&type=template&id=45e8f8d0&"
import script from "./CompetitionAdding.vue?vue&type=script&lang=js&"
export * from "./CompetitionAdding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports